/* eslint-disable */

import axios from "axios";
import { make } from "vuex-pathify";

const url = require("../../client_config/config").url;

const state = {
  user: [],
  documents: [],
  signature: [],
  documentsProgress: [],
  totalProgress: "",
};

const getters = {
  getUser: (state) => state.user,
  getUserDocuments: (state) => state.documents,
};

const actions = {
  async fetchUser({ commit }) {
    try {
      const response = await axios.get(`${url}/users/info`);
      commit("SET_USER", response.data);
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  async fetchUserDocuments({ commit }, id) {
    try {
      const response = await axios.get(`${url}/employeeDocuments`);
      commit("SET_USER_DOCUMENT", response.data.document);
      return response;
    } catch (error) {
      console.error(e.response);
      return error.response;
    }
  },

  async getDocuments({ commit }, id) {
    try {
      const response = await axios.get(`${url}/employeeDocuments/${id}`);
      commit("SET_USER_DOCUMENT", response.data.document);
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  async saveDocument({ commit }, data) {
    try {
      const response = await axios.patch(
        `${url}/employeeDocuments/employment`,
        data
      );
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async saveInfo({ commit }, data) {
    try {
      const response = await axios.post(`${url}/users/info`, data);
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async saveApplicationDocument({ commit }, data) {
    try {
      const response = await axios.patch(
        `${url}/employeeDocuments/application`,
        data
      );
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async saveNoncompeteDocument({ commit }, data) {
    try {
      const response = await axios.patch(
        `${url}/employeeDocuments/noncompete`,
        data
      );
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async saveNonsolicitationDocument({ commit }, data) {
    try {
      const response = await axios.patch(
        `${url}/employeeDocuments/nonsolicitation`,
        data
      );
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async saveTrainingDocument({ commit }, data) {
    try {
      const response = await axios.patch(
        `${url}/employeeDocuments/training`,
        data
      );
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async saveTransportationDocument({ commit }, data) {
    try {
      const response = await axios.patch(
        `${url}/employeeDocuments/transportation/`,
        data
      );
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async updateDocument({ commit }, { data, pdfDocument, employeeID }) {
    try {
      const response = await axios.patch(
        `${url}/employeeDocuments/document/${employeeID}`, data,
        {
          params: { document: pdfDocument },
        }
      );
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },


  async downloadDocuments({ commit }, { id, pdfDocument }) {
    try {
      const response = await axios.get(
        `${url}/employeeDocuments/${id}/download`,
        {
          params: { document: pdfDocument },
        }
      );
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async saveUserProgress({ commit }, data) {
    try {
      const response = await axios.patch(`${url}/users/`, data);
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  addSignature({ commit }, data) {
    try {
      commit("ADD_SIGNATURE", data);
    } catch (error) {
      console.error(error);
    }
  },

  addProgress({ commit }, data) {
    try {
      commit("ADD_PROGRESS", data);
    } catch (error) {
      console.error(error);
    }
  },
};

const mutations = {
  ...make.mutations(state),
  SET_USER(state, data) {
    state.user = data;
  },
  SET_USER_DOCUMENT(state, data) {
    state.documents = data;
  },
  ADD_SIGNATURE(state, data) {
    /* 
      This will store employee signature in the state
      Employee signature will be stored by signed documents
      Or we can use 1 signature and then populate all signature to Employee's document
    */
    for (const [key, value] of Object.entries(data)) {
      let found = state.signature.some((obj) => {
        if (Object.keys(obj)[0] === key) {
          obj[key] = value;
          return true;
        }
      });
      if (!found) {
        state.signature.push({ [key]: value });
      }
      console.log(state.signature);
    }
  },

  ADD_PROGRESS(state, data) {
    for (const [key, value] of Object.entries(data)) {
      let found = state.documentsProgress.some((obj) => {
        if (Object.keys(obj)[0] === key) {
          obj[key] = value;
          return true;
        }
      });
      if (!found) {
        state.documentsProgress.push({ [key]: value });
      }
    }

    const totalPoints = state.documentsProgress
      .map((object) => {
        return Object.values(object).reduce((totalPoints, key) => {
          return totalPoints + key;
        }, 0);
      })
      .reduce((acc, cur) => acc + cur);

    state.totalProgress = Math.ceil((100 / 6) * totalPoints);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
